<template>
  <div>
    <Form
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="版本名称" prop="VersionName">
        <Input v-model="addModel.VersionName" placeholder="版本名称"></Input>
      </FormItem>
      <FormItem label="版本号" prop="VersionCode">
        <Input v-model="addModel.VersionCode"></Input>
      </FormItem>

      <FormItem label="服务" >
        <!-- <dicTree @selectTreeData="selectdicTreeData"></dicTree> -->
        <Button type="primary" @click="dictreeModel = true">选择服务</Button>
        <span class="ml-5">{{ addModel.DicName }}</span>
      </FormItem>
      <FormItem label="更新设备" >
        <Button type="primary" @click="clienttreeModel = true">选择设备</Button>
        <span class="ml-5 limitshow">{{ addModel.ClientName }}</span>
      </FormItem>
      <FormItem label="是否强制更新">
        <i-switch v-model="addModel.ForceUpdate" size="large">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
      <FormItem label="备注">
        <Input
          v-model="addModel.Remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <Upload
      ref="uploadFile"
      :action="uploadUrl"
      :headers="headers"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
      <!-- :show-upload-list="false" -->
      <Button icon="ios-cloud-upload-outline">选择压缩包</Button>
    </Upload>

    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')"
        >确 定</Button
      >
    </div>
    <Modal
      v-model="dictreeModel"
      title="选择服务"
      @on-ok="okdicModal"
      @on-cancel="canceldicModal"
    >
      <dicTree  v-if="dictreeModel" @selectTreeData="selectdicTreeData"></dicTree>
    </Modal>
    <Modal
      v-model="clienttreeModel"
      title="选择客户端"
      @on-ok="okclientModal"
      @on-cancel="cancelclientModal"
    >
      <clientTree  v-if="clienttreeModel" @selectTreeData="selectClientTreeData"></clientTree>
    </Modal>
  </div>
</template>
<script>
import dicTree from "./selectDic.vue";
import clientTree from "./selectClient.vue";
import organTree from "../../basedata/organ/organTree.vue";
import token from "../../../utils/token.js";
export default {
  components: { organTree, dicTree, clientTree },
  data: function () {
    return {
      treeModel: false,
      dictreeModel: false,
      clienttreeModel: false,
      organParentName: "",
      DicIdtemp: "",
      DicNametemp: "",
      ClientNametemp: "",
      ClientSNtemp: [],
      fileName: "",
      headers: "",
      uploadUrl: "",
      addModel: {
        VersionName: "",
        VersionCode: 0,
        Remark: "",
        ClientSNs: [],
        ClientName: "",
        ForceUpdate: true,
        DicId: "",
        DicName: "",
        UpdateFilePath: "",
      },
      SecretTypeSelect: [],
      ruleValidate: {
        VersionName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        VersionCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        DicName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        UpdateFilePath: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.SecretTypeSelect = this.$common.getJsonData("clientType");
    let baseUrl = localStorage.getItem("baseURL");
    this.uploadUrl = baseUrl + "/clientversion/uploadrar";
    this.headers = { Authorization: "Bearer " + token.getToken() };
   
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("clientVersion/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
    selectTreeData: function (data) {
      //  this.DicIdtemp= data[0].organID;
      //   this.addModel.organName = data[0].title;
    },
    selectdicTreeData: function (data) {
      if (data && data.length > 0) {
        if (data[0].isroot) {
          alert("请选择子节点");
          return;
        }
        this.DicIdtemp = data[0].id;
        this.DicNametemp = data[0].title;
      }
    },
    okdicModal() {
      this.addModel.DicId = this.DicIdtemp;
      this.addModel.DicName = this.DicNametemp;
    },
    canceldicModal() {},

    selectClientTreeData: function (data) {
      console.log(`selected item:${JSON.stringify(data)}`);

      let showclient = [];
      let showclientSN = [];

      data.forEach(function (item, idnex) {
        if (!item.isroot) {
          showclient.push(item.title);
          showclientSN.push(item.id);
        }
      });
      this.ClientSNtemp = showclientSN;
      this.ClientNametemp = showclient.join(",");
    },
    okclientModal() {
      this.addModel.ClientSNs = this.ClientSNtemp;
      this.addModel.ClientName = this.ClientNametemp;
    },
    cancelclientModal() {},
    //导入
    uploadSuccess: function (response, file, fileList) {
      if (response.statusCode == 200) {
        this.$Message.success("上传成功");
        this.addModel.UpdateFilePath = response.data;
        this.fileName = file.name;
      } else {
        this.$Message.success(response.msg);
      }
    },

    cancel: function () {},
    uploadError: function (error, file, fileList) {
      this.$Message.success("上传失败");
    },
  },
};
</script>
<style scoped>
.limitshow {
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>